import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { PageSubTitle } from 'Components/Titles';
import { PromoCodeForm } from 'Forms/PromoCodeForm/PromoCodeForm';
import { MILITARYGIFT_COUPON, MILITARYDEAL_COUPON } from 'Utils/Constants';
import { scrollToElementWithDelay } from 'Utils/Utils';
import { getFeatureFlag } from 'Utils/FeatureFlags';

export const ManagePromotion = forwardRef(({ subTitle, onSubmitPromoCode, validPromoMsg }, ref) => {
  const promoWrapper = useRef(null);
  const [isScrolled, setScrolled] = useState(false);
  const [couponCode, setCouponCode] = useState('');
  const promoCodeForm = useRef(null);

  const handleInitialize = (initialValue, forceScroll = false, delay = 750) => {
    if ((!isScrolled || forceScroll) && promoWrapper && promoWrapper.current) {
      setCouponCode(initialValue);
      setScrolled(true);

      // targets redfast banner above ManagePromotion component.
      scrollToElementWithDelay(promoWrapper.current.previousElementSibling, delay);
    }
  };

  useImperativeHandle(ref, () => ({
    setTmtBannerCode: (code) => {
      promoCodeForm?.current?.setFormFieldValue(code);
      handleInitialize(code, true, 300);
    },
  }));

  return (
    <div className="sectionFlex" ref={promoWrapper}>
      <div className="flexGrowOne settingsSectionLeft">
        <PageSubTitle text={subTitle} />
      </div>
      <div className="sectionFlex flexDirCol flexGrowTwo settingsSectionRight">
        <div className="sectionFlex promoCodeSection">
          <PromoCodeForm
            ref={promoCodeForm}
            submitButtonText="Apply"
            onFormSubmit={onSubmitPromoCode}
            validPromoMsg={validPromoMsg}
            onChange={setCouponCode}
            onInitialize={handleInitialize}
            canAutoApplyCoupon={false}
            displaySuccessPopup={true}
          />
        </div>
        {(couponCode.toUpperCase() === MILITARYGIFT_COUPON || couponCode.toUpperCase() === 'DOWNLOAD') && (
          <div className="sectionFlex promoCodeLegalText">
            *By clicking &quot;Apply&quot;, you will immediately be billed $32.49, and your two-year renewal offer
            period will begin. Any remaining months from your first free year will be applied at the end of this
            two-year renewal offer period. After the two-year renewal period and the remaining months from your first
            free year expires, your subscription will automatically renew at the then-current rates for Military &amp;
            Vet subscription plans for one year, unless you cancel 24 hours before renewal date. The renewal charges
            will be applied to the payment method associated with your account, and you hereby authorize Fox News
            Network, LLC or its designee to make such charge. We will send a confirmation to the email address
            associated with your account describing the plan change and how to cancel before the next renewal.
          </div>
        )}
        {couponCode.toUpperCase() === MILITARYDEAL_COUPON && (
          <div className="sectionFlex promoCodeLegalText">
            *By clicking &quot;Apply&quot;, you will immediately be billed $19.50, and your one-year renewal offer
            period will begin. Any remaining months from your first free year will be applied at the end of this
            one-year renewal offer period. After the one-year renewal period and the remaining months from your first
            free year expires, your subscription will automatically renew at the then-current rates for Military &amp;
            Veterans subscription plans for one year, unless you cancel 24 hours before renewal date. The renewal
            charges will be applied to the payment method associated with your account, and you hereby authorize Fox
            News Network, LLC or its designee to make such charge. We will send a confirmation to the email address
            associated with your account describing the plan change and how to cancel before the next renewal.
          </div>
        )}
      </div>
    </div>
  );
});
